import { useState } from 'react'

const useLoading = (defaultValue = false) => {
  const [loading, setLoading] = useState(defaultValue)
  const startLoading = () => setLoading(true)
  const stopLoading = () => setLoading(false)
  return [loading, startLoading, stopLoading]
}

export default useLoading
